/* @flow */

import * as React from 'react';

import SoundController from './utils/SoundController';

export type AppContextType = {
  soundController: SoundController,
};

export default React.createContext<?AppContextType>(null);
